import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
//toast
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {notify} from "../../functions/tostify";
//components
import SignupInput from "./SignupInput";
import FetchLoading from "../FetchLoading";
// services
import {Login} from "../../services/Login";
//redux
import {useDispatch} from 'react-redux';
import {loginHandler} from '../../features/authentication';

const Signup = () => {
    localStorage.setItem('check_first', JSON.stringify({
        dashboard: false,
        myClass: false,
        onlineGame: false,
    }))

    const [phoneNumber, setPhoneNumber] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    //navigate
    const navigate = useNavigate();
    //redux
    const dispatch = useDispatch();

    //send code function
    const SetFocusOnPasswordBox = () => {
    };

    //submit function
    const signInHandler = () => {
        const phoneResult = /^09[0-9]{9}$/.test(phoneNumber);

        //fetch handler
        if (phoneResult) {
            setLoading(true)
            Login({phonenumber: phoneNumber, password: password})
                .then((response) => {
                    dispatch(loginHandler(response.data));
                    navigate('/dashboard/');
                })
                .catch((error) => {
                    console.log(error.response.data)
                    if ((error.response.status === 422 || error.response.status === 401) && (error.response.data === "wrong code" || error.response.data === "Validation error." || error.response.data === "Invalid Credentials"))
                        notify("شماره تلفن یا رمز عبور وارد شده صحیح نیست", "error")
                    else
                        notify("ارتباط با سرور برقرار نشد. لطفا دقایقی دیگر تلاش کنید.", "error")
                    setLoading(false)
                })
        } else {
            notify("شماره تلفن وارد شده صحیح نیست", "error")
        }

    };

    return (
        <div
            className="overflow-hidden w-screen h-screen flex-row flex items-center">
            <ToastContainer toastStyle={{borderRadius: 'min(1vw,2vh)'}} rtl/>
            {loading && <FetchLoading/>}
            <div
                className="flex justify-center flex-col items-center w-full h-full">
                <h1 className="font-bold font-boldFA text-[min(4vw,8vh)] text-white mb-[min(3vw,6vh)]">کارنمای سازمانی زی بازی</h1>
                <div className="flex flex-col justify-center items-center w-[min(40vw,80vh)] z-[2] h-[min(33vw,66vh)] bg-[#001037] rounded-[min(1vw,2vh)]">
                    <h3 className="font-bold font-boldFA text-[min(4vw,8vh)] text-white mb-[min(3vw,6vh)]">ورود</h3>
                    <div className="flex flex-col justify-between w-[64%] h-[30%]">

                        <SignupInput
                            onChange={(value) => {
                                const inputValue = value.replace(/[^0-9]/g, '').slice(0, 11);
                                setPhoneNumber(inputValue)
                            }}
                            icon_name={"phone.svg"}
                            value={phoneNumber}
                            placeholder={"شماره تلفن"}
                            type={"number"}
                            active={true}
                            enterAction={SetFocusOnPasswordBox}

                        />
                        <SignupInput
                            onChange={(value) => {
                                setPassword(value)
                            }}
                            icon_name={"pass.svg"}
                            value={password}
                            placeholder={"رمز عبور"}
                            type={"text"}
                            active={true}
                            enterAction={signInHandler}
                        />


                    </div>

                    <div className="relative flex items-end w-[50%] h-[12%] mt-[10%]">
                        <div onClick={signInHandler} className='flex justify-center items-center absolute w-full h-[92%] bg-[#4044ED] rounded-[min(0.5vw,1vh)] text-[min(1.2vw,2.5vh)] font-normal text-white'>وارد شوید</div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Signup;